// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PtaW","comment":"styles_comment__Xbc46"};